import { useEffect, useState } from "react";
import { feastChoices } from "@/lib/consecrationDates";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/calendar`;
export const useConsecrationFeasts = (initialYear) => {
  const [year, setYear] = useState(initialYear);
  const [years, setYears] = useState([]);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError("");
    fetch(`${API}/catalog`, { signal: controller.signal }).then(async (response) => {
      if (!response.ok) throw new Error();
      const catalog = await response.json();
      const available = catalog.find((item) => item.id === "roman-of")?.years;
      if (!available?.length) throw new Error();
      setYears(available);
      setYear((value) => available.includes(value) ? value : available[available.length - 1]);
    }).catch((err) => { if (err.name !== "AbortError") setError("Feast dates could not be loaded. Try again, or choose your own start date."); });
    return () => controller.abort();
  }, [retry]);
  useEffect(() => {
    if (!years.includes(year)) return;
    const controller = new AbortController();
    setResult(null); setError("");
    fetch(`${API}/events?year=${year}&calendar=roman-of`, { signal: controller.signal }).then(async (response) => {
      if (!response.ok) throw new Error();
      const records = await response.json();
      const feasts = feastChoices(records, year);
      if (!feasts.length) throw new Error();
      setResult({ year, feasts });
    }).catch((err) => { if (err.name !== "AbortError") setError("Feast dates could not be loaded. Try again, or choose your own start date."); });
    return () => controller.abort();
  }, [year, years, retry]);
  return { year, setYear, years, feasts: result?.year === year ? result.feasts : [], loading: !error && result?.year !== year, error, retry: () => setRetry((value) => value + 1) };
};